/**
 * How a typed line is compared with the mnemonic it is supposed to produce.
 *
 * The same rule as `RoteLine` in the core, and deliberately so: typing has to answer immediately —
 * a network call per keystroke would be unusable on a train — while the core keeps the authority and
 * checks the last typed line again when the drill is finished. That the rule exists twice is
 * affordable because it is two lines long. An edit distance would have been a second formula to keep.
 */
export function normalizeRoteLine(text: string): string {
  return text.replace(/\s+/gu, '').toLowerCase()
}

export function roteLineMatches(target: string, typed: string): boolean {
  const wanted = normalizeRoteLine(target)
  return wanted !== '' && wanted === normalizeRoteLine(typed)
}
